import React from 'react';
import { usePage } from '@inertiajs/react';

const ValidationErrors = ({ className }) => {
  const { props } = usePage();
  const { errors } = props;
  const hasErrors = Object.keys(errors).length > 0;

  if (!hasErrors) {
    return null;
  }

  return (
    <div className={className}>
      <div className="font-medium text-red-600">
        Whoops! Something went wrong.
      </div>
    </div>
  );
};

export default ValidationErrors;
